import { render } from "./ChamarDemanda.vue?vue&type=template&id=77227b2f&scoped=true"
import script from "./ChamarDemanda.vue?vue&type=script&lang=js"
export * from "./ChamarDemanda.vue?vue&type=script&lang=js"

import "./ChamarDemanda.vue?vue&type=style&index=0&id=77227b2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77227b2f"]])

export default __exports__